/**
 * Created by Ning Jiang on 3/28/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {
    IStillImageBackgroundConfig,
    StillImageBackground
} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {PixiesVsPiratesGameConfig} from "../PixiesVsPiratesGameConfig";
import {TimelineLite, Power1, TweenLite} from "gsap";
import {PPFreespinAmbientParticles} from "./PPFreespinAmbientParticles";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";

export class PPBackground extends StillImageBackground {

    private _reelBackground:PIXI.Sprite;
    private _reelForeground:PIXI.Sprite;
    private _logo:PIXI.Sprite;
    private _wheel:PIXI.Sprite;
    private _foreground:PIXI.Sprite;
    private _wheelAnimTimeLine:TimelineLite;
    private _cloudPanningTimeLine:TimelineLite;
    private _cloudsArray:PIXI.Sprite[] = [];
    private _fsAmbientParticles:PPFreespinAmbientParticles;
    private _foregroundSpine:PIXI.spine.Spine;
    private _timeline:TimelineLite;

    constructor(config:IStillImageBackgroundConfig) {
        super(config);
        this._fsAmbientParticles = new PPFreespinAmbientParticles(StageManager.getLayer(PixiesVsPiratesGameConfig.instance.LAYERS.BACKGROUND.name));
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, ScreenEvent.PICK_AND_CLICK_START, (event:GameEvent) => this.startFSAmbientAnimation());
    }

    protected initAnimations():void {
        super.initAnimations();
        const backGroundLayer:ScalableLayer = StageManager.getLayer(PixiesVsPiratesGameConfig.instance.LAYERS.BACKGROUND.name);
        const reelBackgroundLayer:ScalableLayer = StageManager.getLayer(PixiesVsPiratesGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
        const foregroundLayer:ScalableLayer = StageManager.getLayer(PixiesVsPiratesGameConfig.instance.LAYERS.FOREGROUND.name);

        this._foregroundSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("foreground_anim"));
        this._foregroundSpine.autoUpdate = true;
        this._foregroundSpine.state.setAnimation(0, "animation", true);
        this._foregroundSpine.state.setEmptyAnimation(0, 0);

        this._wheel = new PIXI.Sprite(GameResources.getTextures("wheel")[0]);
        this._wheel.anchor.set(0.5, 0.5);
        this._wheel.position.set(GameConfig.instance.GAME_WIDTH / 2, 80);
        reelBackgroundLayer.addChild(this._wheel);

        this._reelBackground = new PIXI.Sprite(GameResources.getTextures("reelBg")[0]);
        this._reelBackground.position.set(331, 127);
        reelBackgroundLayer.addChild(this._reelBackground);

        this._reelForeground = new PIXI.Sprite();
        foregroundLayer.addChild(this._reelForeground);

        this._logo = new PIXI.Sprite(GameResources.getTextures("logo")[0]);
        this._logo.anchor.set(0.5, 0);
        this._logo.position.set(GameConfig.instance.GAME_WIDTH / 2, 11);
        foregroundLayer.addChild(this._logo);

        this._foreground = new PIXI.Sprite();
        this._foreground.scale.set(1.33);
        this._foreground.position.set(598, 318);
        this._foreground.addChild(this._foregroundSpine);
        foregroundLayer.addChild(this._foreground);

        const cloud4:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("cloud1")[0]);
        cloud4.position.set(-cloud4.width, -389);
        backGroundLayer.addChild(cloud4);
        this._cloudsArray.push(cloud4);

        const cloud2:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("cloud2")[0]);
        cloud2.position.set(-cloud2.width + 350, -189);
        backGroundLayer.addChild(cloud2);
        this._cloudsArray.push(cloud2);

        const cloud1:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("cloud1")[0]);
        cloud1.position.set(-(cloud1.width + 700), 321);
        backGroundLayer.addChild(cloud1);
        this._cloudsArray.push(cloud1);

        const cloud3:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("cloud3")[0]);
        cloud3.position.set(-(cloud3.width + 1050), 129);
        backGroundLayer.addChild(cloud3);
        this._cloudsArray.push(cloud3);
    }

    protected onResize(resizeData:IResizeData):void {
        if(this._currentMode === GameMode.NORMAL) {
            this.playCloudPanningAnimation(resizeData.width);
        } else {
            this.stopCloudAnimation();
        }
    }

    private playCloudPanningAnimation(width:number):void {
        this._cloudPanningTimeLine = new TimelineLite();
        if(this._cloudsArray && this._cloudsArray.length > 0) {
            this._cloudsArray.forEach((cloud:PIXI.Sprite, index:number) => {
                cloud.visible = true;
                cloud.position.x = -(cloud.width + (index * 350));
                this._cloudPanningTimeLine.add(this.getCloudAnimation(cloud, index, width), index * 5);
            });
        }
    }

    private getCloudAnimation(cloud:PIXI.Sprite, index:number, width:number):TimelineLite {
        const timeLine:TimelineLite = new TimelineLite({
            onComplete : () => {
                cloud.position.x = -(cloud.width + (index * 350));
                this.getCloudAnimation(cloud, index, width);
                timeLine.pause();
                timeLine.kill();
            }
        });
        timeLine.to(cloud, 300, {x : width});
        return timeLine;
    }

    private stopCloudAnimation():void {
        this._cloudsArray.forEach((cloud:PIXI.Sprite, index:number) => {
            cloud.visible = false;
            cloud.position.x = -(cloud.width + (index * 350));
        });
        if(this._cloudPanningTimeLine && this._cloudPanningTimeLine.isActive()) {
            this._cloudPanningTimeLine.pause();
            this._cloudPanningTimeLine.kill();
        }
    }

    private startFSAmbientAnimation():void {
        // this._fsAmbientParticles.startAnimation();
    }

    protected onChangeBackground(data:IGameModeChangedData):boolean {
        if(!super.onChangeBackground(data)) {
            return false;
        }

        if(this._currentMode === GameMode.NORMAL) {
            this.playForegroundAnim();
            this._fsAmbientParticles.stopAnimation();
            this._logo.visible = true;
            this._reelBackground.visible = true;
            this._foreground.visible = true;
            this._wheel.visible = true;
            // TODO: start wheel animation.
            this.playWheelAnimation();
            this.playCloudPanningAnimation(GameConfig.instance.GAME_WIDTH);
            this._reelForeground.texture = GameResources.getTextures("boardFrame")[0];
            this._reelForeground.position.set(258, 7);
        } else {
            this.stopCloudAnimation();
            this.stopForeGroundAnim();
            this._fsAmbientParticles.startAnimation();
            this._logo.visible = false;
            this._reelBackground.visible = false;
            this._foreground.visible = false;
            this._wheel.visible = false;
            this.stopWheelAnimation();
            this.stopCloudAnimation();
            this._reelForeground.texture = GameResources.getTextures("boardFrameFS")[0];
            this._reelForeground.position.set(259, -52);
        }
        return true;
    }

    private playWheelAnimation():void {
        this._wheelAnimTimeLine = new TimelineLite();
        this._wheelAnimTimeLine.to(this._wheel, 4, {rotation : 1})
            .to(this._wheel, 4, {rotation : 0, ease : Power1.easeInOut, repeat : -1, yoyo : true, repeatDelay : 0.5});
    }

    private stopWheelAnimation():void {
        if(this._wheelAnimTimeLine && this._wheelAnimTimeLine.isActive()) {
            this._wheelAnimTimeLine.pause();
            this._wheelAnimTimeLine.kill();
        }
    }

    private playForegroundAnim():void {
        this.resetTimeline();
        this._foregroundSpine.state.clearTrack(0);
        this._foregroundSpine.skeleton.setToSetupPose();

        this._foreground.alpha = 1;
        this._foreground.visible = true;
        this._timeline = new SpineTween(this._foregroundSpine, 0, "animation", -1);
    }

    private stopForeGroundAnim():void {
        this.resetTimeline();
        if(this._foreground && this._foreground.alpha == 1) {
            const timeline:TimelineLite = new TimelineLite();
            timeline.to(this._foreground, 0.2, {alpha : 0});
            this._timeline = timeline;
        }
    }

    private resetTimeline():void {
        if(this._timeline && this._timeline.isActive()) {
            this._timeline.progress(1);
            this._timeline.kill();
        }
    }
}